export const gplayCountries = [
  {
      name: "Afghanistan",
      code: "AF"
  },
  {
      name: "Albania",
      code: "AL"
  },
  {
      name: "Algeria",
      code: "DZ"
  },
  {
      name: "Andorra",
      code: "AD"
  },
  {
      name: "Angola",
      code: "AO"
  },
  {
      name: "Anguilla",
      code: "AI"
  },
  {
      name: "Antarctica",
      code: "AQ"
  },
  {
      name: "Antigua and Barbuda",
      code: "AG"
  },
  {
      name: "Argentina",
      code: "AR"
  },
  {
      name: "Armenia",
      code: "AM"
  },
  {
      name: "Aruba",
      code: "AW"
  },
  {
      name: "Australia",
      code: "AU"
  },
  {
      name: "Austria",
      code: "AT"
  },
  {
      name: "Azerbaijan",
      code: "AZ"
  },
  {
      name: "Bahamas",
      code: "BS"
  },
  {
      name: "Bahrain",
      code: "BH"
  },
  {
      name: "Bangladesh",
      code: "BD"
  },
  {
      name: "Barbados",
      code: "BB"
  },
  {
      name: "Belarus",
      code: "BY"
  },
  {
      name: "Belgium",
      code: "BE"
  },
  {
      name: "Belize",
      code: "BZ"
  },
  {
      name: "Benin",
      code: "BJ"
  },
  {
      name: "Bermuda",
      code: "BM"
  },
  {
      name: "Bhutan",
      code: "BT"
  },
  {
      name: "Bolivia",
      code: "BO"
  },
  {
      name: "Bonaire, Sint Eustatius and Saba",
      code: "BQ"
  },
  {
      name: "Bosnia and Herzegovina",
      code: "BA"
  },
  {
      name: "Botswana",
      code: "BW"
  },
  {
      name: "Bouvet Island",
      code: "BV"
  },
  {
      name: "Brazil",
      code: "BR"
  },
  {
      name: "British Indian Ocean Territory",
      code: "IO"
  },
  {
      name: "Brunei Darussalam",
      code: "BN"
  },
  {
      name: "Bulgaria",
      code: "BG"
  },
  {
      name: "Burkina Faso",
      code: "BF"
  },
  {
      name: "Burundi",
      code: "BI"
  },
  {
      name: "Cambodia",
      code: "KH"
  },
  {
      name: "Cameroon",
      code: "CM"
  },
  {
      name: "Canada",
      code: "CA"
  },
  {
      name: "Cape Verde",
      code: "CV"
  },
  {
      name: "Cayman Islands",
      code: "KY"
  },
  {
      name: "Central African Republic",
      code: "CF"
  },
  {
      name: "Chad",
      code: "TD"
  },
  {
      name: "Chile",
      code: "CL"
  },
  {
      name: "China",
      code: "CN"
  },
  {
      name: "Christmas Island",
      code: "CX"
  },
  {
      name: "Cocos (Keeling) Islands",
      code: "CC"
  },
  {
      name: "Colombia",
      code: "CO"
  },
  {
      name: "Comoros",
      code: "KM"
  },
  {
      name: "Congo",
      code: "CG"
  },
  {
      name: "Congo, The Democratic Republic of the",
      code: "CD"
  },
  {
      name: "Cook Islands",
      code: "CK"
  },
  {
      name: "Costa Rica",
      code: "CR"
  },
  {
      name: "Croatia",
      code: "HR"
  },
  {
      name: "Cuba",
      code: "CU"
  },
  {
      name: "Curaçao",
      code: "CW"
  },
  {
      name: "Cyprus",
      code: "CY"
  },
  {
      name: "Czech Republic",
      code: "CZ"
  },
  {
      name: "Côte d'Ivoire",
      code: "CI"
  },
  {
      name: "Denmark",
      code: "DK"
  },
  {
      name: "Djibouti",
      code: "DJ"
  },
  {
      name: "Dominica",
      code: "DM"
  },
  {
      name: "Dominican Republic",
      code: "DO"
  },
  {
      name: "Ecuador",
      code: "EC"
  },
  {
      name: "Egypt",
      code: "EG"
  },
  {
      name: "El Salvador",
      code: "SV"
  },
  {
      name: "Equatorial Guinea",
      code: "GQ"
  },
  {
      name: "Eritrea",
      code: "ER"
  },
  {
      name: "Estonia",
      code: "EE"
  },
  {
      name: "Ethiopia",
      code: "ET"
  },
  {
      name: "Falkland Islands (Malvinas)",
      code: "FK"
  },
  {
      name: "Fiji",
      code: "FJ"
  },
  {
      name: "Finland",
      code: "FI"
  },
  {
      name: "France",
      code: "FR"
  },
  {
      name: "French Southern Territories",
      code: "TF"
  },
  {
      name: "Gabon",
      code: "GA"
  },
  {
      name: "Gambia",
      code: "GM"
  },
  {
      name: "Georgia",
      code: "GE"
  },
  {
      name: "Germany",
      code: "DE"
  },
  {
      name: "Ghana",
      code: "GH"
  },
  {
      name: "Gibraltar",
      code: "GI"
  },
  {
      name: "Greece",
      code: "GR"
  },
  {
      name: "Grenada",
      code: "GD"
  },
  {
      name: "Guatemala",
      code: "GT"
  },
  {
      name: "Guernsey",
      code: "GG"
  },
  {
      name: "Guinea",
      code: "GN"
  },
  {
      name: "Guinea-Bissau",
      code: "GW"
  },
  {
      name: "Guyana",
      code: "GY"
  },
  {
      name: "Haiti",
      code: "HT"
  },
  {
      name: "Heard Island and Mcdonald Islands",
      code: "HM"
  },
  {
      name: "Honduras",
      code: "HN"
  },
  {
      name: "Hong Kong",
      code: "HK"
  },
  {
      name: "Hungary",
      code: "HU"
  },
  {
      name: "Iceland",
      code: "IS"
  },
  {
      name: "India",
      code: "IN"
  },
  {
      name: "Indonesia",
      code: "ID"
  },
  {
      name: "Iran, Islamic Republic Of",
      code: "IR"
  },
  {
      name: "Iraq",
      code: "IQ"
  },
  {
      name: "Ireland",
      code: "IE"
  },
  {
      name: "Isle of Man",
      code: "IM"
  },
  {
      name: "Israel",
      code: "IL"
  },
  {
      name: "Italy",
      code: "IT"
  },
  {
      name: "Jamaica",
      code: "JM"
  },
  {
      name: "Japan",
      code: "JP"
  },
  {
      name: "Jersey",
      code: "JE"
  },
  {
      name: "Jordan",
      code: "JO"
  },
  {
      name: "Kazakhstan",
      code: "KZ"
  },
  {
      name: "Kenya",
      code: "KE"
  },
  {
      name: "Kiribati",
      code: "KI"
  },
  {
      name: "Korea, Republic of",
      code: "KR"
  },
  {
      name: "Kuwait",
      code: "KW"
  },
  {
      name: "Kyrgyzstan",
      code: "KG"
  },
  {
      name: "Laos",
      code: "LA"
  },
  {
      name: "Latvia",
      code: "LV"
  },
  {
      name: "Lebanon",
      code: "LB"
  },
  {
      name: "Lesotho",
      code: "LS"
  },
  {
      name: "Liberia",
      code: "LR"
  },
  {
      name: "Libya",
      code: "LY"
  },
  {
      name: "Liechtenstein",
      code: "LI"
  },
  {
      name: "Lithuania",
      code: "LT"
  },
  {
      name: "Luxembourg",
      code: "LU"
  },
  {
      name: "Macao",
      code: "MO"
  },
  {
      name: "Madagascar",
      code: "MG"
  },
  {
      name: "Malawi",
      code: "MW"
  },
  {
      name: "Malaysia",
      code: "MY"
  },
  {
      name: "Maldives",
      code: "MV"
  },
  {
      name: "Mali",
      code: "ML"
  },
  {
      name: "Malta",
      code: "MT"
  },
  {
      name: "Mexico",
      code: "MX"
  },
  {
      name: "Micronesia, Federated States of",
      code: "FM"
  },
  {
      name: "Moldova, Republic of",
      code: "MD"
  },
  {
      name: "Monaco",
      code: "MC"
  },
  {
      name: "Mongolia",
      code: "MN"
  },
  {
      name: "Montenegro",
      code: "ME"
  },
  {
      name: "Montserrat",
      code: "MS"
  },
  {
      name: "Morocco",
      code: "MA"
  },
  {
      name: "Mozambique",
      code: "MZ"
  },
  {
      name: "Myanmar",
      code: "MM"
  },
  {
      name: "Namibia",
      code: "NA"
  },
  {
      name: "Nauru",
      code: "NR"
  },
  {
      name: "Nepal",
      code: "NP"
  },
  {
      name: "Netherlands",
      code: "NL"
  },
  {
      name: "New Zealand",
      code: "NZ"
  },
  {
      name: "Nicaragua",
      code: "NI"
  },
  {
      name: "Niger",
      code: "NE"
  },
  {
      name: "Nigeria",
      code: "NG"
  },
  {
      name: "Niue",
      code: "NU"
  },
  {
      name: "Norfolk Island",
      code: "NF"
  },
  {
      name: "North Macedonia",
      code: "MK"
  },
  {
      name: "Norway",
      code: "NO"
  },
  {
      name: "Oman",
      code: "OM"
  },
  {
      name: "Pakistan",
      code: "PK"
  },
  {
      name: "Palau",
      code: "PW"
  },
  {
      name: "Palestinian Territory",
      code: "PS"
  },
  {
      name: "Panama",
      code: "PA"
  },
  {
      name: "Papua New Guinea",
      code: "PG"
  },
  {
      name: "Paraguay",
      code: "PY"
  },
  {
      name: "Peru",
      code: "PE"
  },
  {
      name: "Philippines",
      code: "PH"
  },
  {
      name: "Pitcairn Islands",
      code: "PN"
  },
  {
      name: "Poland",
      code: "PL"
  },
  {
      name: "Portugal",
      code: "PT"
  },
  {
      name: "Puerto Rico",
      code: "PR"
  },
  {
      name: "Qatar",
      code: "QA"
  },
  {
      name: "Romania",
      code: "RO"
  },
  {
      name: "Russian Federation",
      code: "RU"
  },
  {
      name: "Rwanda",
      code: "RW"
  },
  {
      name: "Saint Helena",
      code: "SH"
  },
  {
      name: "Saint Kitts and Nevis",
      code: "KN"
  },
  {
      name: "Saint Lucia",
      code: "LC"
  },
  {
      name: "Saint Vincent and the Grenadines",
      code: "VC"
  },
  {
      name: "Samoa",
      code: "WS"
  },
  {
      name: "San Marino",
      code: "SM"
  },
  {
      name: "Sao Tome and Principe",
      code: "ST"
  },
  {
      name: "Saudi Arabia",
      code: "SA"
  },
  {
      name: "Senegal",
      code: "SN"
  },
  {
      name: "Serbia",
      code: "RS"
  },
  {
      name: "Seychelles",
      code: "SC"
  },
  {
      name: "Sierra Leone",
      code: "SL"
  },
  {
      name: "Singapore",
      code: "SG"
  },
  {
      name: "Slovakia",
      code: "SK"
  },
  {
      name: "Slovenia",
      code: "SI"
  },
  {
      name: "Solomon Islands",
      code: "SB"
  },
  {
      name: "Somalia",
      code: "SO"
  },
  {
      name: "South Africa",
      code: "ZA"
  },
  {
      name: "South Georgia and the South Sandwich Islands",
      code: "GS"
  },
  {
      name: "Spain",
      code: "ES"
  },
  {
      name: "Sri Lanka",
      code: "LK"
  },
  {
      name: "Sudan",
      code: "SD"
  },
  {
      name: "Suriname",
      code: "SR"
  },
  {
      name: "Eswatini",
      code: "SZ"
  },
  {
      name: "Sweden",
      code: "SE"
  },
  {
      name: "Switzerland",
      code: "CH"
  },
  {
      name: "Taiwan",
      code: "TW"
  },
  {
      name: "Tajikistan",
      code: "TJ"
  },
  {
      name: "Tanzania, United Republic of",
      code: "TZ"
  },
  {
      name: "Thailand",
      code: "TH"
  },
  {
      name: "East Timor",
      code: "TL"
  },
  {
      name: "Togo",
      code: "TG"
  },
  {
      name: "Tokelau",
      code: "TK"
  },
  {
      name: "Tonga",
      code: "TO"
  },
  {
      name: "Trinidad and Tobago",
      code: "TT"
  },
  {
      name: "Tunisia",
      code: "TN"
  },
  {
      name: "Turkey",
      code: "TR"
  },
  {
      name: "Turkmenistan",
      code: "TM"
  },
  {
      name: "Turks and Caicos Islands",
      code: "TC"
  },
  {
      name: "Tuvalu",
      code: "TV"
  },
  {
      name: "Uganda",
      code: "UG"
  },
  {
      name: "Ukraine",
      code: "UA"
  },
  {
      name: "United Arab Emirates",
      code: "AE"
  },
  {
      name: "United Kingdom",
      code: "GB"
  },
  {
      name: "United States",
      code: "US"
  },
  {
      name: "United States Minor Outlying Islands",
      code: "UM"
  },
  {
      name: "Uruguay",
      code: "UY"
  },
  {
      name: "Uzbekistan",
      code: "UZ"
  },
  {
      name: "Vanuatu",
      code: "VU"
  },
  {
      name: "Venezuela",
      code: "VE"
  },
  {
      name: "Vietnam",
      code: "VN"
  },
  {
      name: "Virgin Islands, British",
      code: "VG"
  },
  {
      name: "Western Sahara",
      code: "EH"
  },
  {
      name: "Yemen",
      code: "YE"
  },
  {
      name: "Zambia",
      code: "ZM"
  },
  {
      name: "Zimbabwe",
      code: "ZW"
  },
]


export const iosCountries = [
    {name: 'Algeria', code: 143563},
    {name: 'Angola', code: 143564},
    {name: 'Anguilla', code: 143538},
    {name: 'Antigua & Barbuda', code: 143540},
    {name: 'Argentina', code: 143505},
    {name: 'Armenia', code: 143524},
    {name: 'Australia', code: 143460},
    {name: 'Austria', code: 143445},
    {name: 'Azerbaijan', code: 143568},
    {name: 'Bahrain', code: 143559},
    {name: 'Barbados', code: 143541},
    {name: 'Belarus', code: 143565},
    {name: 'Belgium', code: 143446},
    {name: 'Belize', code: 143555},
    {name: 'Bermuda', code: 143542},
    {name: 'Bolivia', code: 143556},
    {name: 'Botswana', code: 143525},
    {name: 'Brazil', code: 143503},
    {name: 'British Virgin Islands', code: 143543},
    {name: 'Brunei', code: 143560},
    {name: 'Bulgaria', code: 143526},
    {name: 'Canada', code: 143455},
    {name: 'Cayman Islands', code: 143544},
    {name: 'Chile', code: 143483},
    {name: 'China', code: 143465},
    {name: 'Colombia', code: 143501},
    {name: 'Costa Rica', code: 143495},
    {name: 'Croatia', code: 143494},
    {name: 'Cyprus', code: 143557},
    {name: 'Czech Republic', code: 143489},
    {name: 'Denmark', code: 143458},
    {name: 'Dominica', code: 143545},
    {name: 'Dominican Rep.', code: 143508},
    {name: 'Ecuador', code: 143509},
    {name: 'Egypt', code: 143516},
    {name: 'El Salvador', code: 143506},
    {name: 'Estonia', code: 143518},
    {name: 'Finland', code: 143447},
    {name: 'France', code: 143442},
    {name: 'Germany', code: 143443},
    {name: 'Ghana', code: 143573},
    {name: 'Greece', code: 143448},
    {name: 'Grenada', code: 143546},
    {name: 'Guatemala', code: 143504},
    {name: 'Guyana', code: 143553},
    {name: 'Honduras', code: 143510},
    {name: 'Hong Kong', code: 143463},
    {name: 'Hungary', code: 143482},
    {name: 'Iceland', code: 143558},
    {name: 'India', code: 143467},
    {name: 'Indonesia', code: 143476},
    {name: 'Ireland', code: 143449},
    {name: 'Israel', code: 143491},
    {name: 'Italy', code: 143450},
    {name: 'Jamaica', code: 143511},
    {name: 'Japan', code: 143462},
    {name: 'Jordan', code: 143528},
    {name: 'Kazakstan', code: 143517},
    {name: 'Kenya', code: 143529},
    {name: 'Korea, Republic Of', code: 143466},
    {name: 'Kuwait', code: 143493},
    {name: 'Latvia', code: 143519},
    {name: 'Lebanon', code: 143497},
    {name: 'Lithuania', code: 143520},
    {name: 'Luxembourg', code: 143451},
    {name: 'Macau', code: 143515},
    {name: 'Macedonia', code: 143530},
    {name: 'Madagascar', code: 143531},
    {name: 'Malaysia', code: 143473},
    {name: 'Mali', code: 143532},
    {name: 'Malta', code: 143521},
    {name: 'Mauritius', code: 143533},
    {name: 'Mexico', code: 143468},
    {name: 'Moldova, Republic Of', code: 143523},
    {name: 'Montserrat', code: 143547},
    {name: 'Nepal', code: 143484},
    {name: 'Netherlands', code: 143452},
    {name: 'New Zealand', code: 143461},
    {name: 'Nicaragua', code: 143512},
    {name: 'Niger', code: 143534},
    {name: 'Nigeria', code: 143561},
    {name: 'Norway', code: 143457},
    {name: 'Oman', code: 143562},
    {name: 'Pakistan', code: 143477},
    {name: 'Panama', code: 143485},
    {name: 'Paraguay', code: 143513},
    {name: 'Peru', code: 143507},
    {name: 'Philippines', code: 143474},
    {name: 'Poland', code: 143478},
    {name: 'Portugal', code: 143453},
    {name: 'Qatar', code: 143498},
    {name: 'Romania', code: 143487},
    {name: 'Russia', code: 143469},
    {name: 'Saudi Arabia', code: 143479},
    {name: 'Senegal', code: 143535},
    {name: 'Singapore', code: 143464},
    {name: 'Slovakia', code: 143496},
    {name: 'Slovenia', code: 143499},
    {name: 'South Africa', code: 143472},
    {name: 'Spain', code: 143454},
    {name: 'Sri Lanka', code: 143486},
    {name: 'St. Kitts & Nevis', code: 143548},
    {name: 'St. Lucia', code: 143549},
    {name: 'St. Vincent & The Grenadines', code: 143550},
    {name: 'Suriname', code: 143554},
    {name: 'Sweden', code: 143456},
    {name: 'Switzerland', code: 143459},
    {name: 'Taiwan', code: 143470},
    {name: 'Tanzania', code: 143572},
    {name: 'Thailand', code: 143475},
    {name: 'The Bahamas', code: 143539},
    {name: 'Trinidad & Tobago', code: 143551},
    {name: 'Tunisia', code: 143536},
    {name: 'Turkey', code: 143480},
    {name: 'Turks & Caicos', code: 143552},
    {name: 'Uganda', code: 143537},
    {name: 'United Kingdom', code: 143444},
    {name: 'Ukraine', code: 143492},
    {name: 'United Arab Emirates', code: 143481},
    {name: 'Uruguay', code: 143514},
    {name: 'United States', code: 143441},
    {name: 'Uzbekistan', code: 143566},
    {name: 'Venezuela', code: 143502},
    {name: 'Vietnam', code: 143471},
    {name: 'Yemen', code: 143571}
];
